import { render } from "./FileVersions.vue?vue&type=template&id=540e648f"
import script from "./FileVersions.vue?vue&type=script&lang=js"
export * from "./FileVersions.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/mobysuite-docs-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__